import { render, staticRenderFns } from "./Top10Product.vue?vue&type=template&id=bb27b600"
import script from "./Top10Product.vue?vue&type=script&lang=js"
export * from "./Top10Product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb27b600')) {
      api.createRecord('bb27b600', component.options)
    } else {
      api.reload('bb27b600', component.options)
    }
    module.hot.accept("./Top10Product.vue?vue&type=template&id=bb27b600", function () {
      api.rerender('bb27b600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/chart/Top10Product.vue"
export default component.exports